<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
<app-breadcrumbs></app-breadcrumbs>
<router-outlet></router-outlet>

</div>
<app-footer></app-footer>
